// src/redux/reducers/userReducer.js

// Define the initial state
const initialState = {
  uid: null,
  email: null,
  name: null,
};

// Create the reducer function
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        uid: action.payload.uid,
        email: action.payload.email,
        name: action.payload.name,
      };
    case "CLEAR_USER":
      return {
        ...state,
        uid: null,
        email: null,
        name: null,
      };
    default:
      return state;
  }
};

export default userReducer;
